import { AuthService, UserService } from '#services';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export async function appInitializer() {
  const auth = inject(AuthService);
  const userService = inject(UserService);

  // Initialize auth - handles redirects and silent token refresh
  await auth.initialize();

  // If still not authenticated after initialization, trigger login
  if (!auth.isAuthenticated()) {
    await auth.login();
    return;
  }

  // Ensure token is valid before making API calls
  try {
    await auth.acquireTokenSilent();
  } catch {
    console.warn('Token acquisition failed during initialization, will redirect to login');
    await auth.login();
    return;
  }

  // Preload user details for faster navigation
  try {
    const userDetails = await firstValueFrom(userService.getCurrentUser());
    auth.setUserDetails(
      userDetails !== null
        ? {
          id: userDetails.ID,
          email: userDetails.Email,
          hasAccess: userDetails.HasAccess,
          isBuAdmin: userDetails.IsBUAdmin,
          isSysAdmin: userDetails.IsSystemAdmin,
          isOrgAdmin: userDetails.IsOrgAdmin,
          username: auth.getAccountName(),
        }
        : null
    );
  } catch (error) {
    console.error('Failed to load user details during initialization:', error);
    // Don't block app startup if this fails - the guard will retry
  }
}
